import { render, staticRenderFns } from "./AtomStatementsSlider.vue?vue&type=template&id=74788934&scoped=true&"
import script from "./AtomStatementsSlider.vue?vue&type=script&lang=js&"
export * from "./AtomStatementsSlider.vue?vue&type=script&lang=js&"
import style0 from "./AtomStatementsSlider.vue?vue&type=style&index=0&id=74788934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74788934",
  null
  
)

export default component.exports